export function isScoreField(key) {
	const normalized = String(key || '').toLowerCase();
	return normalized === 'confidence_score' || normalized === 'data_completeness';
}

export function scorePercent(value, key) {
	const fieldKey = String(key || '').toLowerCase();
	if (typeof value === 'number') {
		const normalized = value <= 1 ? value * 100 : value;
		return Math.max(0, Math.min(100, Math.round(normalized)));
	}
	if (typeof value === 'string') {
		if (fieldKey === 'data_completeness') {
			const normalizedText = value.trim().toLowerCase();
			if (['full', 'complete', 'high'].includes(normalizedText)) return 100;
			if (['mostly', 'mostly_complete', 'mostly complete'].includes(normalizedText)) return 85;
			if (['partial', 'medium', 'moderate'].includes(normalizedText)) return 65;
			if (['low', 'incomplete', 'minimal', 'poor'].includes(normalizedText)) return 35;
			if (['none', 'missing', 'empty'].includes(normalizedText)) return 0;
		}
		const parsed = parseFloat(value.replace('%', '').trim());
		if (Number.isNaN(parsed)) return null;
		const normalized = parsed <= 1 ? parsed * 100 : parsed;
		return Math.max(0, Math.min(100, Math.round(normalized)));
	}
	return null;
}

export function scoreClass(percent) {
	if (percent == null) return '';
	if (percent >= 85) return 'tnt-score-high';
	if (percent >= 65) return 'tnt-score-mid';
	return 'tnt-score-low';
}
